<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5.16666V8.66666"
      stroke="#D98A11"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.0534 5.72003V10.28C14.0534 11.0267 13.6534 11.72 13.0067 12.1L9.04669 14.3867C8.40002 14.76 7.60001 14.76 6.94668 14.3867L2.98667 12.1C2.34001 11.7267 1.94 11.0333 1.94 10.28V5.72003C1.94 4.97337 2.34001 4.28001 2.98667 3.90001L6.94668 1.61334C7.59334 1.24001 8.39336 1.24001 9.04669 1.61334L13.0067 3.90001C13.6534 4.28001 14.0534 4.9667 14.0534 5.72003Z"
      stroke="#D98A11"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 10.7995V10.8661"
      stroke="#D98A11"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.33333"
    />
  </svg>
</template>
